module.exports = __webpack_public_path__ + "img/unified-app-launch.a2935096.svg";